import _get from 'lodash/get';


export const getLastPayout = state => (
  _get(state, 'payoutSettings.lastPayout.payout')
);
export const getLoadLastPayoutError = state => (
  _get(state, 'payoutSettings.lastPayout.errors.loadLastPayout')
);
